import { Link } from '@inertiajs/react'
import {
  Badge,
  Button,
  Container,
  Group,
  Paper,
  Stack,
  Table,
  Text,
  Title,
} from '@mantine/core'
import { IconEye } from '@tabler/icons-react'
import { StudioLayout } from '../Components/Layouts'

const statusColors = {
  'in-review': 'yellow',
  'changes-requested': 'red',
  approved: 'green',
  promoted: 'blue',
  invalid: 'red',
  'gates-green': 'lime',
  drafting: 'gray',
}

export default function TemplateReviewIndex({ templateReviews }) {
  const items = templateReviews?.items || []
  return (
    <StudioLayout pageTitle="Template reviews">
      <Container size="xl" py="lg">
        <Stack gap="lg">
          <div>
            <Title order={1} size="h3">Template reviews</Title>
            <Text size="sm" c="dimmed" mt={4}>
              Private MCP workspaces awaiting human visual and interactive review.
            </Text>
          </div>
          <Paper withBorder radius="lg" shadow="sm" p="md">
            {items.length ? (
              <Table.ScrollContainer minWidth={760}>
                <Table verticalSpacing="sm" horizontalSpacing="md" highlightOnHover>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>Template</Table.Th>
                      <Table.Th>Status</Table.Th>
                      <Table.Th>Author</Table.Th>
                      <Table.Th>Package</Table.Th>
                      <Table.Th>Updated</Table.Th>
                      <Table.Th />
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {items.map((item) => (
                      <Table.Tr key={item.workspaceId}>
                        <Table.Td>
                          <Text size="sm" fw={650}>{item.name}</Text>
                          <Text size="xs" c="dimmed">{item.releaseKey || item.workspaceId}</Text>
                        </Table.Td>
                        <Table.Td>
                          <Group gap={5}>
                            <Badge color={statusColors[item.status] || 'gray'} variant="light">
                              {item.status}
                            </Badge>
                            {item.quality && (
                              <Badge color={item.quality.current ? 'green' : 'orange'} variant="dot">
                                quality {item.quality.status}
                              </Badge>
                            )}
                          </Group>
                        </Table.Td>
                        <Table.Td><Text size="sm">{item.author || '—'}</Text></Table.Td>
                        <Table.Td>
                          <Text size="xs" ff="monospace">{item.packageSha256?.slice(0, 12) || 'unavailable'}</Text>
                          {item.totalBytes != null && <Text size="xs" c="dimmed">{Number(item.totalBytes).toLocaleString()} bytes</Text>}
                        </Table.Td>
                        <Table.Td><Text size="xs">{item.updatedAt ? new Date(item.updatedAt).toLocaleString() : '—'}</Text></Table.Td>
                        <Table.Td>
                          <Button
                            component={Link}
                            href={item.url}
                            size="compact-sm"
                            variant="light"
                            leftSection={<IconEye size={15} />}
                            disabled={item.status === 'invalid'}
                          >
                            Review
                          </Button>
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                </Table>
              </Table.ScrollContainer>
            ) : (
              <Group justify="center" py="xl">
                <Text size="sm" c="dimmed">No MCP template workspaces are available.</Text>
              </Group>
            )}
          </Paper>
        </Stack>
      </Container>
    </StudioLayout>
  )
}
